import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { MenuState } from './state';
import { Site } from '@/models/Site';
import { StatutBim } from '@/models/StatutBim';

export const getters: GetterTree<MenuState, RootState> = {
    getMenu(state) {
        return state.menu;
    },
    getChoixMenu(state): string | undefined {
        return state.choixMenu;
    },
    getSitesDisponibles(state): Site[] {
        return state.listeSiteDisponibles;
    },
    getOnBoardingOpen(state): boolean {
        return state.onBoardingOpen;
    },
    getStatutBim(state): StatutBim {
        return state.statutBim;
    },
    getMenuWithBim(state): any[] {
        const menu = JSON.parse(JSON.stringify(state.menu));
        if (state.statutBim?.bimVisible) {
            const administratif = menu.find((item: any) => item.child?.some((c: any) => c.href === '/equipements'));
            if (administratif && !administratif.child.some((c: any) => c.href === '/bim')) {
                administratif.child.push({
                    title: 'B.I.M.',
                    href: '/bim',
                    icon: 'none',
                });
            }
        }
        return menu;
    },
};
